import React from 'react';
import PropTypes from 'prop-types';
import handleKeyPress from '../../common/handleKeyPress';
import * as Styled from './styles';

const AlignmentButton = ({ icon, label, align, updateAlignment }) => (
    <Styled.ModalOption
        onClick={() => updateAlignment(align)}
        onKeyDown={(e) => handleKeyPress(e, () => updateAlignment(align))}
    >
        <i className="material-icons" style={{ fontSize: 18 }}>
            {icon}
        </i>
        <Styled.Paragraph>{label}</Styled.Paragraph>
    </Styled.ModalOption>
);

AlignmentButton.propTypes = {
    icon: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    align: PropTypes.string.isRequired,
    updateAlignment: PropTypes.func.isRequired,
};

export default AlignmentButton;
